








































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { EventBus } from '../../event-bus';
import { reorder } from '@/utils/reorder';
import SlideReferenceItem from './SlideReferenceItem.vue';
import { getReferences } from '../../services/graph/slide.graph';
// import SortableList from "../../components/hoc-dnd/SortableList";
// import SortableItem from "../../components/hoc-dnd/SortableItem.vue";
import ReferenceAssignDialogVue from '../dialogs/ReferenceAssignDialog.vue';
import { cloneDeep } from 'apollo-utilities';
import { StateBus } from '../../state-bus';
import { namespace } from 'vuex-class';
import { uniqBy } from 'lodash';

const stateBus = new StateBus();

const references = namespace('slides/references');

@Component({
  components: {
    item: SlideReferenceItem,
    referenceAssignDialog: ReferenceAssignDialogVue
  }
})
export default class SlideReferenceContainer extends Vue {
  private loading: boolean = false;
  private subLoading: boolean = false;

  private statesCount: number = 0;

  private prefix: string[] = [];
  private refs: { text: string; _id: string }[] = [];

  private mode: 'save' | 'add' = 'add';
  private dialog: boolean = false;

  @references.Action('reloadReferences') reloadReferences!: (slideId: string) => Promise<void>;
  @references.Action('updateReferences') updateReferences!: (a: {
    slideId: string;
    refs: any[];
    prefix: any[];
  }) => Promise<void>;

  mounted() {
    this.loadReferences();
    stateBus.observe((count: number) => {
      this.statesCount = count;
      if (count > 1) {
        this.mode = 'save';
      } else {
        this.mode = 'add';
      }
    });
    EventBus.$on('update-reference', (slideId: string) => {
      this.loadReferences(slideId);
    });
  }

  @Watch('$route.query.asset')
  slideIdChanged(newId: string) {
    if (newId) {
      this.loadReferences(newId);
    }
  }

  async onReferenceDelete(index: number) {
    this.refs.splice(index, 1);
    if (this.prefix[index]) {
      this.prefix.splice(index, 1);
    }

    stateBus.addState({ prefix: this.prefix, refs: this.refs });
  }

  async onAddingReferences(refs: any[]) {
    if (refs) {
      this.refs = uniqBy([...this.refs, ...refs], x => x._id);
      this.subLoading = true;
      try {
        await this.storeUpdateReferences(this.$route.query.asset);
        this.$store.dispatch('alerts/success', 'Added references successfully');
        this.reloadSlide(this.$route.query.asset as string);
      } catch (error) {
        this.resetState();
        this.$store.dispatch('alerts/warning', 'Not able to save references');
      } finally {
        this.subLoading = false;
      }
    }
  }

  async reloadSlide(id: string) {
    try {
      await this.$store.dispatch('slides/getActive', id);
    } catch (error) {
      await this.$store.dispatch('alerts/warning', 'Not able to reload slide image, reloading page.');
      window.location.reload();
    }
  }

  changedPrefix(e: any) {
    stateBus.addState({ prefix: this.prefix, refs: this.refs });
    this.prefix[e.index] = e.val;
    Vue.set(this.prefix, e.index, e.val);
  }

  changeSort(e: any) {
    const arr = cloneDeep(this.refs);
    const prefix = cloneDeep(this.prefix);
    stateBus.addState({ prefix: this.prefix, refs: this.refs });
    if (e.removedIndex !== e.addedIndex) {
      reorder(arr, e.removedIndex, e.addedIndex);

      if (prefix[e.removedIndex] || prefix[e.addedIndex]) {
        reorder(prefix, e.removedIndex, e.addedIndex);
      }

      this.refs = arr;
      this.prefix = prefix;
    }
  }

  goBack() {
    const state = stateBus.revertState();
    if (state) {
      this.prefix = state.prefix;
      this.refs = state.refs;
    }
  }

  resetState() {
    const state = stateBus.resetState();
    if (state) {
      this.prefix = state.prefix;
      this.refs = state.refs;
    }
  }

  async loadReferences(id: string | (string | null)[] = this.$route.query.asset) {
    this.loading = true;
    this.resetState();
    try {
      const slide = await getReferences(id as string);
      this.prefix = slide.references.prefix;
      this.refs = slide.references.refs;
      stateBus.addState({
        prefix: slide.references.prefix,
        refs: slide.references.refs
      });
    } catch (error) {
      await this.$store.dispatch('alerts/warning', 'Not able to load references');
    } finally {
      this.loading = false;
    }
  }

  async storeUpdateReferences(id: string | (string | null)[] = this.$route.query.asset) {
    const prefix = cloneDeep(this.prefix);
    const refs = cloneDeep(this.refs);
    this.subLoading = true;
    try {
      await this.updateReferences({
        slideId: id as string,
        prefix: prefix,
        refs: refs
      });
      this.$store.dispatch('alerts/success', 'Added references successfully');
      this.reloadSlide(id as string);
      this.loadReferences();
    } catch (error) {
      this.$store.dispatch('alerts/warning', 'Not able to update references.');
    } finally {
      this.resetState();
      this.subLoading = false;
    }
  }
}
